import { useEffect, useState } from 'react'

import { Events } from 'constants/events'
import checkIosDevice from 'utils/checkIosDevice'

const refreshLayout = () => {
  document.documentElement.style.height = `initial`
  setTimeout(() => {
    document.documentElement.style.height = `100%`
    setTimeout(() => {
      window.scrollTo(0, 1)
    }, 200)
  }, 200)
}

const useIOSOrientation = (dependency: any) => {
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    setIsIOS(checkIosDevice())
  }, [])

  useEffect(() => {
    if (isIOS && dependency) {
      window.addEventListener(Events.ORIENTATION_CHANGE, refreshLayout)
      return () => window.removeEventListener(Events.ORIENTATION_CHANGE, refreshLayout)
    }
    window.removeEventListener(Events.ORIENTATION_CHANGE, refreshLayout)
  }, [isIOS, dependency])

  return isIOS
}

export default useIOSOrientation
